type ContractStatusRow = Record<string, any>;

export const normalizeEventContractStatusRow = (row: ContractStatusRow) => ({
  artist_id: row.artist_id || null,
  artist_name: row.artist_name || '',
  profile_picture: row.profile_picture || null,
  gender: row.gender || null,
  status: String(row.status || '').toLowerCase(),
  invoice_resubmission_requested: row.invoice_resubmission_requested === true,
  contract_id: row.contract_id || null,
  contract_artist_id: row.contract_artist_id || null,
  last_ts: row.last_ts || row.lastTs || null,
  event_count: Number(row.event_count) || 0,
  payment_item_label: row.payment_item_label || '出演料',
  main_fee: Number(row.main_fee ?? row.fee ?? 0) || 0,
  additional_rewards: Array.isArray(row.additional_rewards) ? row.additional_rewards : [],
  additional_reward_total: Number(row.additional_reward_total ?? 0) || 0,
  supplemental_invoice_total: Number(row.supplemental_invoice_total ?? 0) || 0,
  supplemental_invoice_count: Number(row.supplemental_invoice_count ?? 0) || 0,
  reward_total: Number(row.reward_total ?? 0) || 0,
});

export const buildEventContractRewardPresentation = ({
  entry,
  contractArtistId,
  index,
}: {
  entry: ContractStatusRow;
  contractArtistId?: unknown;
  index: number;
}) => {
  const rewardLines: Array<Record<string, any>> = [];
  const mainAmount = Number(entry.main_fee);
  if (Number.isFinite(mainAmount)) {
    rewardLines.push({
      key: `main-${contractArtistId || index}`,
      label: String(entry.payment_item_label || '出演料').trim() || '出演料',
      amount: Math.max(0, Math.floor(mainAmount)),
    });
  }
  const additional = Array.isArray(entry.additional_rewards) ? entry.additional_rewards : [];
  additional.forEach((row, rewardIndex) => {
    const amount = Number(row?.amount);
    if (!Number.isFinite(amount)) return;
    rewardLines.push({
      key: `${row?.id || contractArtistId || index}-${rewardIndex}`,
      label: String(row?.item_label || '追加支払い').trim() || '追加支払い',
      amount: Math.max(0, Math.floor(amount)),
    });
  });
  const supplementalTotal = Math.max(0, Math.floor(Number(entry.supplemental_invoice_total) || 0));
  const supplementalCount = Math.max(0, Math.floor(Number(entry.supplemental_invoice_count) || 0));
  if (supplementalTotal > 0 || supplementalCount > 0) {
    rewardLines.push({
      key: `supplemental-${contractArtistId || index}`,
      label: `追補請求${supplementalCount > 0 ? `（${supplementalCount}件）` : ''}`,
      amount: supplementalTotal,
      kind: 'supplemental',
    });
  }
  const calculatedRewardTotal = rewardLines.reduce((sum, line) => sum + line.amount, 0);
  const apiRewardTotal = Number(entry.reward_total);
  return {
    rewardLines,
    rewardTotal: Number.isFinite(apiRewardTotal) && apiRewardTotal > 0
      ? Math.max(0, Math.floor(apiRewardTotal))
      : calculatedRewardTotal,
  };
};
